module.exports = __webpack_public_path__ + "static/media/asxv3.b2765e8e.png";